import * as Yup from "yup";

const schema = Yup.object({
  permissions: Yup.array().of(Yup.string()),
  policyByPermission: Yup.object().default({}),
});

export default schema;
